import React, { ButtonHTMLAttributes } from 'react';

import { Container } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  _hoverColor?: string;
  _bgColor?: string;
  _textColor?: string;
};

const SigninButton: React.FC<ButtonProps> = ({ children, loading, _hoverColor='', _bgColor='', _textColor='', ...rest }) => (
  <Container _hoverColor={_hoverColor} _bgColor={_bgColor} _textColor={_textColor} type="button" {...rest}>
    {loading ? 'Loading...' : children}
  </Container>
);

export default SigninButton;